/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {
    WKBottomBtn
} from '../wk'

class Footer extends React.Component {

    render() {
        const {urlData} = this.props;
        const btnContent = {
            text: '邀请嘉宾',
            method: () => {
                window.location.href = `/${urlData.type}/${urlData.target_id}/invite/card`
            },
            bcolor: '#FF5A31'
        };

        return (
            <WKBottomBtn btnContent={btnContent} />
        )
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/lecturerInvite/Footer.js